// extracted by mini-css-extract-plugin
export var fullHeightState = "_2e-7";
export var headerCell = "_2e-1";
export var loadingStateCell = "_2e-4";
export var rowWrapper = "_2e-3";
export var standaloneTable = "_2e-8";
export var standaloneTableWithBodyFill = "_2e-9";
export var stateCell = "_2e-5";
export var table = "_2e-0";
export var tableBodyFiller = "_2e-6";
export var white = "_2e-2";